// extracted by mini-css-extract-plugin
export var boxItems = "_8i-1";
export var boxItemsLg = "_8i-2";
export var button = "_8i-7";
export var buttonHoverless = "_8i-9";
export var buttonLg = "_8i-8";
export var filterGroupBox = "_8i-0";
export var icon = "_8i-3";
export var iconSecondary = "_8i-6";
export var iconWrapper = "_8i-4";
export var iconWrapperLg = "_8i-5";
export var truncatedLabel = "_8i-a";